(function () {
  'use strict';

  function node(source, selector) {
    return source && source.querySelector ? source.querySelector(selector) : null;
  }

  function apply(source) {
    var freshTitle = source && typeof source.title === 'string' ? source.title.trim() : '';
    var freshCanonical = node(source, 'link[rel="canonical"]');
    var freshDescription = node(source, 'meta[name="description"]');
    var freshItemList = node(source, '[data-ch-collection-item-list]');
    var liveCanonical = node(document, 'link[rel="canonical"]');
    var liveDescription = node(document, 'meta[name="description"]');
    var liveOpenGraphUrl = node(document, 'meta[property="og:url"]');
    var liveItemList = node(document, '[data-ch-collection-item-list]');
    var canonicalHref = freshCanonical && freshCanonical.getAttribute('href');
    var description = freshDescription && freshDescription.getAttribute('content');
    var itemList;

    try {
      itemList = freshItemList && JSON.parse(freshItemList.textContent);
    } catch (error) {
      return false;
    }

    if (!freshTitle || !canonicalHref || description === null || !itemList || itemList['@type'] !== 'ItemList') return false;
    if (!liveCanonical || !liveDescription || !liveOpenGraphUrl || !liveItemList) return false;

    document.title = freshTitle;
    liveCanonical.setAttribute('href', canonicalHref);
    liveDescription.setAttribute('content', description);
    liveOpenGraphUrl.setAttribute('content', canonicalHref);
    liveItemList.textContent = freshItemList.textContent;
    return true;
  }

  window.ChagualCollectionSeoSync = { apply: apply };
}());
